module.exports = __webpack_public_path__ + "img/ThorntonTherapeutic.f5ee15de.webp";